<template>
    <div class="container" v-loading="tableing">
        <div class="header">科目列表
            <el-button class="exit" size="mini" @click="exit()"><img src="../../../static/images/end-back.png" alt="" srcset=""> 返回上一页 </el-button>
        </div>
        <div class="main">
            <div class="orgList" v-for="(item,index) in list" :key="index" @click="comeExamList(item.id)" :style="{background:((index+1)%3==1? 'rgb(0, 75, 180)':index%3==2?'rgb(156, 149, 219)':'rgb(96, 161, 261)')}">
                <div class="orgList-bg" 
                    :style="{backgroundPosition:((index+1)%3==1? '22% 35px,100% 0px':index%3==2?'55% 35px,100% 0px':'40% 35px,100% 0px')}"
                >
                    <div class="orgList-imgBox">
                    <img class="orgList-img" src="../../../static/images/type-img.png" alt="" srcset="">
                    </div>
                    <span class="orgList-name">{{item.name}}</span>
                    <span class="orgList-text">去评测 <i class="el-icon-arrow-right"></i></span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name:"chooseOrg",
        data() {
            return {
                tableing:false,
                list:[]
            }
        },
        components:{},
        watch: {},
        computed:{},
        created(){},
        mounted(){
            this.getData()
        },
        methods:{
            getData(){
                let that = this
                that.tableing = true
                that.$axios.post('/paper/acg/subjectList',{
                    orgId:that.$route.query.id,
                    uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web'))),
                }, res => {
                    that.tableing = false;
                    let v = res.data;
                    if (v.code == 0) {
                        that.list = v.data
                    }else{
                        if(v.msg)
                            that.$message.error(v.msg);
                        else
                            that.$message.error('请求错误');
                    }
                })
            },
            comeExamList(id){
                this.$nextTick(()=>{
                    this.$router.push({
                        path: '/examList',
                        query: {
                            id:id,
                            upId:this.$route.query.id
                        }
                    })
                })
            },
            exit(){
                this.$router.push({
                    path: '/chooseOrg'
                })
            }
        }
    }
</script>
<style scoped lang="less">
    .container{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 19px;
        font-weight: bold;
        color: #000;
        .exit{
            background-color: rgb(96,161,251);
            border: none;
            font-size: 13px;
            color: #fff;
            position: absolute;
            top: 20px;
            right: 10%;
            img{
                height: 10px;
            }
        }
    }
    .main{
        position: absolute;
        top: 60px;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
    }
    .orgList{
        background-color: rgb(246, 246, 246);
        height: 60px;
        width: 80%;
        margin: 0 auto;
        display: block;
        margin-bottom: 20px;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); 
        position: relative;
    }
    .orgList-bg{
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        background-image: url('../../../static/images/bg_bottom.png'),url('../../../static/images/bg_top.png');
        background-repeat: no-repeat;
        background-size: 12% 100%,6% 50%;
        // background-position: 22% 35px,100% 0px;
    }     
    .orgList:hover {
        background-color: #f4f0f0;
    }
    .orgList:active {
        background-color: rgba(46, 103, 222, 0.13);
        height: 59.5px;
        width: 79.9%;
    }    
    .orgList-imgBox{
        width: 12%;
        height: 100%;
        float: left;
        text-align: right;
        box-sizing: border-box;
        padding-right: 8px;
        padding-top: 11px;
        padding-bottom: 9px;
    }
    .orgList-img{
        max-width: 100%;
        max-height:100%;
    }
    .orgList-name{
        box-sizing: border-box;
        padding-left: 8px;
        width: 70%;
        height: 60px;
        line-height: 60px;
        float: left;
        text-align: left;
        display: inline-block;
        font-family: STHeiti;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
    }
    .orgList-text{
        float: left;
        width: 10%;
        height: 30px;
        min-width: 96px;
        box-sizing: border-box;
        padding-left: 15px;
        // padding-right: 10px;
        margin-top: 15px;
        line-height: 30px;
        text-align: left;
        display: inline-block;
        font-family: STHeiti;
        font-size: 15px;
        color: #000;
        font-weight: bold;
        border-radius: 4px;
        background: #Fff;
        i{
            vertical-align: middle;
            margin-top:-3px;
        }
        i::before{
           margin-left: 1px;
           color: #000; 
           font-size: 18px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/chooseType/typeList.vue